// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3381c386] .row-accessories-blue {\n  background-color: rgb(57, 26, 196) !important;\n}\n[data-v-3381c386] .row-accessories-green {\n  background-color: #c0dcc0 !important;\n}\n[data-v-3381c386] .row-accessories-yellow {\n  background-color: #fcfa98 !important;\n}\n[data-v-3381c386] .row-accessories-orange {\n  background-color: #f8d69c !important;\n}\n[data-v-3381c386] .row-accessories-red_ligt {\n  background-color: #f58484 !important;\n}", ""]);
// Exports
module.exports = exports;
